var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"RedChirp Home"}},[_c('v-container',[_c('m-select-employee-endpoint',{attrs:{"selected_endpoint":null},on:{"select":_vm.onSelectEndpoint}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }